import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { HELP_LINKS } from '../config/helpLinks';

/**
 * Placeholder for the user guide.
 *
 * The nav entry needs a real destination — a link to a page that does not exist
 * would 404, and a dead `#` href would be a nav item that silently does nothing.
 * So the stub is an honest page: it says the guide is not written, and points at
 * the things that do exist in the meantime.
 */
export function UserGuidePage() {
  const feedback = HELP_LINKS.filter((l) => l.external);

  return (
    <ContentLayout
      header={
        <Header variant="h1" description="How to use Ticket Insights.">
          User guide
        </Header>
      }
    >
      <Container>
        <SpaceBetween size="m">
          <Alert type="info" header="Coming soon">
            This guide has not been written yet.
          </Alert>

          <Box variant="p">
            In the meantime: <b>Tickets</b> lists everything ingested, with AI summaries on each
            ticket. <b>Reports</b> covers weekly status and root-cause themes. <b>Settings</b> holds
            the ingestion filters and AI configuration, the controls for syncing and targeted
            re-summarizing, and AI experiments for trying a candidate model or prompt without
            touching production summaries.
          </Box>

          {feedback.length > 0 && (
            <Box variant="p">
              Something unclear or missing?{' '}
              {feedback.map((l, i) => (
                <span key={l.id}>
                  {i > 0 && ' · '}
                  <Link href={l.href} external externalIconAriaLabel="(opens in a new tab)">
                    {l.text}
                  </Link>
                </span>
              ))}
            </Box>
          )}
        </SpaceBetween>
      </Container>
    </ContentLayout>
  );
}
